import { sub } from 'date-fns'

import { TimeRange, TimeScale } from 'types'

export const calculatePreviousTimeRange = ({
  range,
  scale,
}: {
  range: TimeRange
  scale: TimeScale
}) => {
  const toValue = range.from

  if (scale === TimeScale.Hourly) {
    return {
      from: sub(toValue, { hours: 24 }).getTime(),
      to: sub(toValue, { seconds: 1 }).getTime(),
    }
  }
  if (scale === TimeScale.Daily) {
    return {
      from: sub(toValue, { weeks: 2 }).getTime(),
      to: sub(toValue, { days: 1 }).getTime(),
    }
  }
  const newToValue = sub(toValue, { weeks: 1 }).getTime()

  return {
    from: sub(toValue, { weeks: 12 }).getTime(),
    to: newToValue,
  }
}
